



























































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Actions, Mutations, FormModes } from '@/ts/store/Constants';
import InlineImages from '@/components/Gallery/InlineImages.vue';
import TextfieldEditor from '@/components/TextfieldEditor.vue';
import Recipients from '@/components/Selects/Recipients.vue';
import RecipientMethods from '@/mixins/RecipientMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import CalendarEventData from '@/ts/CalendarEventData';
import SidebarCheckbox from '@/components/Admin/Layout/SidebarCheckbox.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';

@Component({
    components: {
        InlineImages,
        TextfieldEditor,
        Recipients,
        SidebarCheckbox,
        DatePicker,
    },
})
export default class EventForm extends Mixins(InputFieldMethods, RecipientMethods, LocalizationMethods, NotifyMethods) {
    @Prop({ default: 'create' }) public mode: string;

    public form: any = {
        title: '',
        description: '',
        startTime: null,
        endTime: null,
        zip: '',
        address: '',
        city: '',
        country: '',
        publishedAt: null,
    };
    public dataParsed: boolean = false;

    public hasRecipientsError: boolean = false;
    public eventMainImage: File|null = null;
    public mainImagePreview: string|null = null;
    public attachedImageWasDeleted: boolean = false;

    get isEditing(): boolean {
        return this.mode === FormModes.Edit;
    }

    get isCreating(): boolean {
        return this.mode === FormModes.Create;
    }

    get showEventScheduling(): boolean {
        return this.isCreating || (
            this.isEditing && this.event.publishedAt !== null && !this.event.queueIsExecuted
        );
    }

    get event(): CalendarEventData {
        return this.$store.getters['Events/activeEvent'];
    }

    get eventRecipients(): any {
        return this.event ? {
            corporations: this.event.corporations,
            projects: this.event.projects,
            buildings: this.event.buildings,
            properties: this.event.properties,
        } : {
            corporations: [],
            projects: [],
            buildings: [],
            properties:  [],
        };
    }

    get media() {
        return this.$store.getters['Events/getActiveEventMedia'];
    }

    get mainImage() {
        if (this.isEditing && this.media && !this.attachedImageWasDeleted) {
            return this.media.base64;
        }

        if (this.mainImagePreview) {
            return this.mainImagePreview;
        }

        return null;
    }

    get getCountriesData(): any {
        return this.$store.getters['Properties/allCountries'];
    }

    get addressIsRequired(): boolean {
        if (this.form.zip === null || this.form.address === null || this.form.city === null || this.form.country === null) {
            return false;
        }

        return (
            this.form.zip.trim() !== '' ||
            this.form.address.trim() !== '' ||
            this.form.city.trim() !== '' ||
            this.form.country !== ''
        );
    }

    get schedulingMinDate() {
        return this.$moment().local().format('YYYY-MM-DD HH:mm:ss');
    }

    public setDescription(message: string) {
        this.form.description = message;
    }

    public resetForm() {
        this.form.title       = '';
        this.form.description = '';
        this.form.zip         = '';
        this.form.address     = '';
        this.form.city        = '';
        this.form.country     =  '';
        this.form.startTime   = null;
        this.form.endTime     = null;
        this.form.publishedAt = null;
    }

    public addEventImage() {
        this.markAttachedImageAsDeleted();

        const element = (this.$refs.eventMainPhoto as HTMLInputElement);
        this.eventMainImage = element.files.length === 0 ? null : (element.files[0] as File);

        if (element.files.length === 0) {
            element.type = 'text';
            element.type = 'file';
        }
    }

    @Watch('form.publishedAt')
    public publishedAtChanged() {
        this.$emit('publishedAtChanged', this.form.publishedAt);
    }

    @Watch('eventMainImage')
    public eventMainImageChanged() {
        if (this.eventMainImage !== null) {
            const reader = new FileReader();
            reader.readAsDataURL(this.eventMainImage);

            reader.onload = (e: any) => {
                this.mainImagePreview = e.target.result;
            };

            return;
        }

        this.mainImagePreview = null;
    }

    @Watch('selectedRecipientsWithActionTargets')
    public recipientsChanged() {
        this.hasRecipientsError = false;
    }

    public deleteImage() {
        this.attachedImageWasDeleted ? this.removeImage() : this.markAttachedImageAsDeleted();
    }

    public removeImage() {
        const element = (this.$refs.eventMainPhoto as HTMLInputElement);

        this.eventMainImage   = null;
        this.mainImagePreview = null;

        element.type = 'text';
        element.type = 'file';
    }

    public markAttachedImageAsDeleted() {
        this.attachedImageWasDeleted = true;
    }

    public prependEditFormData(event: CalendarEventData) {
        if (!this.isEditing) {
            return;
        }

        this.form.title       = event.title;
        this.form.description = event.body;
        this.form.startTime   = event.eventStart;
        this.form.endTime     = event.eventEnd;
        this.form.address     = event.address !== null ? event.address.street : null;
        this.form.city        = event.address !== null ? event.address.city : null;
        this.form.zip         = event.address !== null ? event.address.zip : null;
        this.form.country     = event.address !== null ? event.address.countryId : null;
        this.form.publishedAt = event.publishedAt;

        this.$nextTick(() => {
            this.dataParsed = true;
        });
    }

    public create() {
        this.hasRecipientsError = !this.hasRecipients(this.selectedRecipientsWithActionTargets, true);

        this.$validator.validate().then((valid) => {
            if (valid) {
                if (this.hasRecipientsError) {
                    return;
                }

                if (new Date(this.form.startTime).getTime() > new Date(this.form.endTime).getTime()) {
                    return this.notify('event_start_time_must_be_before_event_end_time', 'warning');
                }

                const address = this.addressIsRequired
                    ? {
                        street: this.form.address,
                        city: this.form.city,
                        zip: this.form.zip,
                        countryId: this.form.country,
                    }
                    : null;

                this.$store.dispatch(Actions.HIDE_FORM);

                this.$store.dispatch(Actions.POST_EVENTS, {
                    title: this.form.title,
                    description: this.form.description,
                    eventStart: this.form.startTime,
                    eventEnd: this.form.endTime,
                    address,
                    requiresResponse: true,
                    actionTarget: this.recipientsIds,
                    mainImage: this.eventMainImage,
                    publishedAt: this.form.publishedAt,
                });
            }
        });
    }

    public update() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (new Date(this.form.startTime).getTime() > new Date(this.form.endTime).getTime()) {
                    return this.notify('event_start_time_must_be_before_event_end_time', 'warning');
                }

                const address = this.addressIsRequired
                    ? {
                        street: this.form.address,
                        city: this.form.city,
                        zip: this.form.zip,
                        countryId: this.form.country,
                    }
                    : null;

                this.$store.dispatch(Actions.EDIT_EVENT, {
                    id: this.event.id,
                    title: this.form.title,
                    description: this.form.description,
                    eventStart: this.form.startTime,
                    eventEnd: this.form.endTime,
                    address,
                    requiresResponse: this.event.requiresResponse,
                    mainImage: this.eventMainImage,
                    mainImageRemoved: this.attachedImageWasDeleted,
                    publishedAt: this.form.publishedAt,
                });

                this.$store.commit(Mutations.HIDE_EDIT_EVENT_FORM);
            }
        });
    }

    public close(): void {
        this.resetForm();
        this.resetRecipients();

        if (this.isEditing) {
            this.$store.commit(Mutations.HIDE_EDIT_EVENT_FORM);
        } else {
            this.$store.dispatch(Actions.HIDE_FORM);
        }

        this.$nextTick(() => {
            this.errors.clear();
            this.$validator.reset();
        });
    }

    public created() {
        this.$store.commit(Mutations.SET_ACTIVE_EVENT_MEDIA, null);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_COUNTRIES);

        if (this.isEditing) {
            this.prependEditFormData(this.event);
            this.$store.dispatch(Actions.FETCH_EVENT_MEDIA, this.event.id);
        } else {
            this.dataParsed = true;
        }
    }
}
